module.exports = __webpack_public_path__ + "static/media/uosgy_mobile_top.26e0a4aa.jpg";